import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export interface ImageProps {
  $objectFit?: 'contain' | 'none' | 'cover' | 'fill' | 'scale-down';
}

export const Img = styled.img<ImageProps>`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => props.$objectFit};
`;
